"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotesScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../../components");
var _types = require("../../../types");
var _Screen = require("./Screen");
var _VideoChatCubbyContext = require("../VideoChatCubbyContext");
var _utils = require("../utils");
var _utils2 = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var canSubmitNotesSection = function canSubmitNotesSection(note) {
  var _note$subjective, _note$objective, _note$assessment, _note$plan;
  return !!((_note$subjective = note.subjective) !== null && _note$subjective !== void 0 && _note$subjective.trim() && (_note$objective = note.objective) !== null && _note$objective !== void 0 && _note$objective.trim() && (_note$assessment = note.assessment) !== null && _note$assessment !== void 0 && _note$assessment.trim() && (_note$plan = note.plan) !== null && _note$plan !== void 0 && _note$plan.trim());
};
var Title = function Title(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("h3", {
    className: (0, _classnames.default)('tw-label-sm-medium text-black', className)
  }, children);
};
var NoteField = function NoteField(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    placeholder = _ref2.placeholder,
    field = _ref2.field,
    _ref2$canEdit = _ref2.canEdit,
    canEdit = _ref2$canEdit === void 0 ? true : _ref2$canEdit;
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    readonly = _useVideoChatCubby.readonly,
    setNewNote = _useVideoChatCubby.setNewNote,
    newNote = _useVideoChatCubby.newNote;
  var handleChange = function handleChange(e) {
    setNewNote(_objectSpread(_objectSpread({}, newNote), {}, _defineProperty({}, field, e.target.value)));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[8px]"
  }, /*#__PURE__*/_react.default.createElement(Title, null, title), description && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-caption-light text-grey-55"
  }, description), !canEdit || readonly ? /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-label-regular text-black"
  }, newNote[field]) : field ? /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    multiline: true,
    resizable: true,
    rows: 2,
    placeholder: placeholder,
    onChange: handleChange,
    value: newNote[field]
  }) : null);
};
var NotesScreen = function NotesScreen() {
  var _useVideoChatCubby2 = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    onSetStatus = _useVideoChatCubby2.onSetStatus,
    newNote = _useVideoChatCubby2.newNote,
    updateNote = _useVideoChatCubby2.updateNote;
  return /*#__PURE__*/_react.default.createElement(_Screen.Screen, {
    actionLabel: "Submit",
    actionDisabled: !canSubmitNotesSection(newNote),
    onAction: function onAction() {
      onSetStatus(_utils.VideoChatCubbyScreen.Notes, _utils.NoteSectionStatus.Complete);
      updateNote(_objectSpread(_objectSpread({}, newNote), {}, {
        soapStatus: _types.SessionNoteStatus.Submitted
      })).then(function () {
        _utils2.toast.success({
          title: 'Submitted session note'
        });
      });
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-[20px] flex flex-col gap-y-[20px]"
  }, /*#__PURE__*/_react.default.createElement(NoteField, {
    title: "Subjective",
    placeholder: "Enter patient\u2019s reason for visit",
    field: "subjective",
    canEdit: newNote.canEditSubjective
  }), /*#__PURE__*/_react.default.createElement(NoteField, {
    title: "Objective",
    placeholder: "Enter relevant patient appearance, behavior, speech, or patterns",
    field: "objective"
  }), /*#__PURE__*/_react.default.createElement(NoteField, {
    title: "Assessment",
    placeholder: "Please note the patient\u2019s progress and/or risk factors",
    field: "assessment"
  }), /*#__PURE__*/_react.default.createElement(NoteField, {
    title: "Plan",
    description: "Please note: The following message will be shared with your patient to inform them of the next steps in their treatment.",
    placeholder: "Outline the next steps for the patient\u2019s treatment",
    field: "plan"
  }), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "border-grey-40",
    dashed: true
  }), /*#__PURE__*/_react.default.createElement(NoteField, {
    title: "Additional notes (optional)",
    placeholder: "Add any additional notes",
    field: "additionalNotes"
  })));
};
exports.NotesScreen = NotesScreen;